
import { route } from 'quasar/wrappers'
import { createRouter, createMemoryHistory, createWebHistory, createWebHashHistory } from 'vue-router'

import { useAuth } from 'src/composables/auth';

/*
 * If not building with SSR mode, you can
 * directly export the Router instantiation;
 *
 * The function below can be async too; either use
 * async/await or return a Promise which resolves
 * with the Router instance.
 */

let routes = [{
	name: 'main',
	path: '/',
	component: () => import('layouts/MainLayout.vue'),
	children: [
		//Dashboard routes


//cis_agendamento routes
		{ path: '/cis_agendamento', name: 'cis_agendamentolist', component: () => import('pages/cis_agendamento/list.vue'), props: true },
		{ path: '/cis_agendamento/index/:fieldName?/:fieldValue?', component: () => import('pages/cis_agendamento/list.vue'), props: true },
		{ path: '/cis_agendamento/view/:id', name: 'cis_agendamentoview', component: () => import('pages/cis_agendamento/view.vue'), props: true },
		{ path: '/cis_agendamento/add', name: 'cis_agendamentoadd', component: () => import('pages/cis_agendamento/add.vue'), props: true },
		{ path: '/cis_agendamento/edit/:id', name: 'cis_agendamentoedit', component: () => import('pages/cis_agendamento/edit.vue'), props: true },

//cis_satisfacao routes
		{ path: '/cis_satisfacao', name: 'cis_satisfacaolist', component: () => import('pages/cis_satisfacao/list.vue'), props: true },
		{ path: '/cis_satisfacao/index/:fieldName?/:fieldValue?', component: () => import('pages/cis_satisfacao/list.vue'), props: true },
		{ path: '/cis_satisfacao/view/:id', name: 'cis_satisfacaoview', component: () => import('pages/cis_satisfacao/view.vue'), props: true },
		{ path: '/cis_satisfacao/add', name: 'cis_satisfacaoadd', component: () => import('pages/cis_satisfacao/add.vue'), props: true },
		{ path: '/cis_satisfacao/edit/:id', name: 'cis_satisfacaoedit', component: () => import('pages/cis_satisfacao/edit.vue'), props: true },

//permissions routes
		{ path: '/permissions', name: 'permissionslist', component: () => import('pages/permissions/list.vue'), props: true },
		{ path: '/permissions/index/:fieldName?/:fieldValue?', component: () => import('pages/permissions/list.vue'), props: true },
		{ path: '/permissions/view/:id', name: 'permissionsview', component: () => import('pages/permissions/view.vue'), props: true },
		{ path: '/permissions/add', name: 'permissionsadd', component: () => import('pages/permissions/add.vue'), props: true },
		{ path: '/permissions/edit/:id', name: 'permissionsedit', component: () => import('pages/permissions/edit.vue'), props: true },

//roles routes
		{ path: '/roles', name: 'roleslist', component: () => import('pages/roles/list.vue'), props: true },
		{ path: '/roles/index/:fieldName?/:fieldValue?', component: () => import('pages/roles/list.vue'), props: true },
		{ path: '/roles/view/:id', name: 'rolesview', component: () => import('pages/roles/view.vue'), props: true },
		{ path: '/roles/add', name: 'rolesadd', component: () => import('pages/roles/add.vue'), props: true },
		{ path: '/roles/edit/:id', name: 'rolesedit', component: () => import('pages/roles/edit.vue'), props: true },

//satisfacao_feedbacks routes
		{ path: '/satisfacao_feedbacks', name: 'satisfacao_feedbackslist', component: () => import('pages/satisfacao_feedbacks/list.vue'), props: true },
		{ path: '/satisfacao_feedbacks/index/:fieldName?/:fieldValue?', component: () => import('pages/satisfacao_feedbacks/list.vue'), props: true },

//tb_cbo routes
		{ path: '/tb_cbo', name: 'tb_cbolist', component: () => import('pages/tb_cbo/list.vue'), props: true },
		{ path: '/tb_cbo/index/:fieldName?/:fieldValue?', component: () => import('pages/tb_cbo/list.vue'), props: true },
		{ path: '/tb_cbo/view/:id', name: 'tb_cboview', component: () => import('pages/tb_cbo/view.vue'), props: true },
		{ path: '/tb_cbo/add', name: 'tb_cboadd', component: () => import('pages/tb_cbo/add.vue'), props: true },
		{ path: '/tb_cbo/edit/:id', name: 'tb_cboedit', component: () => import('pages/tb_cbo/edit.vue'), props: true },

//tb_cidadao routes
		{ path: '/tb_cidadao', name: 'tb_cidadaolist', component: () => import('pages/tb_cidadao/list.vue'), props: true },
		{ path: '/tb_cidadao/index/:fieldName?/:fieldValue?', component: () => import('pages/tb_cidadao/list.vue'), props: true },
		{ path: '/tb_cidadao/view/:id', name: 'tb_cidadaoview', component: () => import('pages/tb_cidadao/view.vue'), props: true },
		{ path: '/tb_cidadao/add', name: 'tb_cidadaoadd', component: () => import('pages/tb_cidadao/add.vue'), props: true },
		{ path: '/tb_cidadao/edit/:id', name: 'tb_cidadaoedit', component: () => import('pages/tb_cidadao/edit.vue'), props: true },

//tb_escolaridade routes
		{ path: '/tb_escolaridade', name: 'tb_escolaridadelist', component: () => import('pages/tb_escolaridade/list.vue'), props: true },
		{ path: '/tb_escolaridade/index/:fieldName?/:fieldValue?', component: () => import('pages/tb_escolaridade/list.vue'), props: true },
		{ path: '/tb_escolaridade/view/:id', name: 'tb_escolaridadeview', component: () => import('pages/tb_escolaridade/view.vue'), props: true },
		{ path: '/tb_escolaridade/add', name: 'tb_escolaridadeadd', component: () => import('pages/tb_escolaridade/add.vue'), props: true },
		{ path: '/tb_escolaridade/edit/:id', name: 'tb_escolaridadeedit', component: () => import('pages/tb_escolaridade/edit.vue'), props: true },

//tb_estado_civil routes
		{ path: '/tb_estado_civil', name: 'tb_estado_civillist', component: () => import('pages/tb_estado_civil/list.vue'), props: true },
		{ path: '/tb_estado_civil/index/:fieldName?/:fieldValue?', component: () => import('pages/tb_estado_civil/list.vue'), props: true },
		{ path: '/tb_estado_civil/view/:id', name: 'tb_estado_civilview', component: () => import('pages/tb_estado_civil/view.vue'), props: true },
		{ path: '/tb_estado_civil/add', name: 'tb_estado_civiladd', component: () => import('pages/tb_estado_civil/add.vue'), props: true },
		{ path: '/tb_estado_civil/edit/:id', name: 'tb_estado_civiledit', component: () => import('pages/tb_estado_civil/edit.vue'), props: true },

//tb_etnia routes
		{ path: '/tb_etnia', name: 'tb_etnialist', component: () => import('pages/tb_etnia/list.vue'), props: true },
		{ path: '/tb_etnia/index/:fieldName?/:fieldValue?', component: () => import('pages/tb_etnia/list.vue'), props: true },
		{ path: '/tb_etnia/view/:id', name: 'tb_etniaview', component: () => import('pages/tb_etnia/view.vue'), props: true },
		{ path: '/tb_etnia/add', name: 'tb_etniaadd', component: () => import('pages/tb_etnia/add.vue'), props: true },
		{ path: '/tb_etnia/edit/:id', name: 'tb_etniaedit', component: () => import('pages/tb_etnia/edit.vue'), props: true },

//tb_localidade routes
		{ path: '/tb_localidade', name: 'tb_localidadelist', component: () => import('pages/tb_localidade/list.vue'), props: true },
		{ path: '/tb_localidade/index/:fieldName?/:fieldValue?', component: () => import('pages/tb_localidade/list.vue'), props: true },
		{ path: '/tb_localidade/view/:id', name: 'tb_localidadeview', component: () => import('pages/tb_localidade/view.vue'), props: true },
		{ path: '/tb_localidade/add', name: 'tb_localidadeadd', component: () => import('pages/tb_localidade/add.vue'), props: true },
		{ path: '/tb_localidade/edit/:id', name: 'tb_localidadeedit', component: () => import('pages/tb_localidade/edit.vue'), props: true },

//tb_pais routes
		{ path: '/tb_pais', name: 'tb_paislist', component: () => import('pages/tb_pais/list.vue'), props: true },
		{ path: '/tb_pais/index/:fieldName?/:fieldValue?', component: () => import('pages/tb_pais/list.vue'), props: true },
		{ path: '/tb_pais/view/:id', name: 'tb_paisview', component: () => import('pages/tb_pais/view.vue'), props: true },
		{ path: '/tb_pais/add', name: 'tb_paisadd', component: () => import('pages/tb_pais/add.vue'), props: true },
		{ path: '/tb_pais/edit/:id', name: 'tb_paisedit', component: () => import('pages/tb_pais/edit.vue'), props: true },

//tb_raca_cor routes
		{ path: '/tb_raca_cor', name: 'tb_raca_corlist', component: () => import('pages/tb_raca_cor/list.vue'), props: true },
		{ path: '/tb_raca_cor/index/:fieldName?/:fieldValue?', component: () => import('pages/tb_raca_cor/list.vue'), props: true },
		{ path: '/tb_raca_cor/view/:id', name: 'tb_raca_corview', component: () => import('pages/tb_raca_cor/view.vue'), props: true },
		{ path: '/tb_raca_cor/add', name: 'tb_raca_coradd', component: () => import('pages/tb_raca_cor/add.vue'), props: true },
		{ path: '/tb_raca_cor/edit/:id', name: 'tb_raca_coredit', component: () => import('pages/tb_raca_cor/edit.vue'), props: true },

//tb_tipo_logradouro routes
		{ path: '/tb_tipo_logradouro', name: 'tb_tipo_logradourolist', component: () => import('pages/tb_tipo_logradouro/list.vue'), props: true },
		{ path: '/tb_tipo_logradouro/index/:fieldName?/:fieldValue?', component: () => import('pages/tb_tipo_logradouro/list.vue'), props: true },
		{ path: '/tb_tipo_logradouro/view/:id', name: 'tb_tipo_logradouroview', component: () => import('pages/tb_tipo_logradouro/view.vue'), props: true },
		{ path: '/tb_tipo_logradouro/add', name: 'tb_tipo_logradouroadd', component: () => import('pages/tb_tipo_logradouro/add.vue'), props: true },
		{ path: '/tb_tipo_logradouro/edit/:id', name: 'tb_tipo_logradouroedit', component: () => import('pages/tb_tipo_logradouro/edit.vue'), props: true },

//tb_uf routes
		{ path: '/tb_uf', name: 'tb_uflist', component: () => import('pages/tb_uf/list.vue'), props: true },
		{ path: '/tb_uf/index/:fieldName?/:fieldValue?', component: () => import('pages/tb_uf/list.vue'), props: true },
		{ path: '/tb_uf/view/:id', name: 'tb_ufview', component: () => import('pages/tb_uf/view.vue'), props: true },
		{ path: '/tb_uf/add', name: 'tb_ufadd', component: () => import('pages/tb_uf/add.vue'), props: true },
		{ path: '/tb_uf/edit/:id', name: 'tb_ufedit', component: () => import('pages/tb_uf/edit.vue'), props: true },

//users routes
		{ path: '/users', name: 'userslist', component: () => import('pages/users/list.vue'), props: true },
		{ path: '/users/index/:fieldName?/:fieldValue?', component: () => import('pages/users/list.vue'), props: true },
		{ path: '/users/view/:id', name: 'usersview', component: () => import('pages/users/view.vue'), props: true },
		{ path: '/index/register', name: 'usersuserregister', component: () => import('pages/index/userregister.vue'), props: true },
		{ path: '/account/edit', name: 'usersaccountedit', component: () => import('pages/account/accountedit.vue'), props: true },
		{ path: '/account', name: 'usersaccountview', component: () => import('pages/account/accountview.vue'), props: true },
		{ path: '/users/add', name: 'usersadd', component: () => import('pages/users/add.vue'), props: true },
		{ path: '/users/edit/:id', name: 'usersedit', component: () => import('pages/users/edit.vue'), props: true },

		{ path: '/humanizacao', name: 'humanizacao', component: () => import('pages/custom/humanizacao.vue'), props: true },
		
		
//Password reset routes
		{ path: '/index/forgotpassword', name: 'forgotpassword', component: () => import('pages/index/forgotpassword.vue') },
		{ path: '/index/resetpassword', name: 'resetpassword', component: () => import('pages/index/resetpassword.vue') },
		{ path: '/index/resetpassword_completed', name: 'resetpassword_completed', component: () => import('pages/index/resetpassword_completed.vue') },
		
		

		//Error pages
		{ path:  '/error/forbidden', name: 'forbidden',  component: () => import('pages/errors/forbidden.vue') },
		{ path: '/error/notfound',  name: 'notfound', component: () => import('pages/errors/pagenotfound.vue') }
	],
	
	},
	{ path: '/:catchAll(.*)*', component: () => import('pages/errors/pagenotfound.vue') }
];

export default route(async function () {
  const createHistory = process.env.SERVER
    ? createMemoryHistory
    : (process.env.VUE_ROUTER_MODE == 'history' ? createWebHistory : createWebHashHistory)
	
	let mainRoute = routes.find(x => x.name = "main");
	
	const auth = useAuth();


	
	//get current user data from api on first load
	const user = await auth.getUserData();
	if(user){
		const homeRoute = {path: '/', alias: '/home', name: 'home', component: () => import('pages/home/home.vue') }
		mainRoute.children.push(homeRoute);
	}
	else{
		const indexRoute = { path: '/',  alias: '/home', name: 'index', component: () => import('pages/index/index.vue') }
		mainRoute.children.push(indexRoute);
	}


	const Router = createRouter({
    scrollBehavior: () => ({ left: 0, top: 0 }),
    routes,
    // Leave this as is and make changes in quasar.conf.js instead!
    // quasar.conf.js -> build -> vueRouterMode
    // quasar.conf.js -> build -> publicPath
    history: createHistory(process.env.VUE_ROUTER_BASE)
  })
  return Router
})

